import { render } from "./HistoryFilters.vue?vue&type=template&id=5be98f7a&ts=true"
import script from "./HistoryFilters.vue?vue&type=script&lang=ts"
export * from "./HistoryFilters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__